import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m2.995 15.74.036-.019zM7.908 7.403"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "m12.37 11.306 7.673 4.178h-.014l.816.442c.693.376 1.155 1.084 1.155 1.888 0 .58-.244 1.136-.677 1.546S20.3 20 19.688 20H4.312c-.613 0-1.201-.23-1.635-.64A2.13 2.13 0 0 1 2 17.814c0-.804.462-1.512 1.155-1.888l.816-.442h-.02l6.839-3.751-.064-.182v-.001l-.003-.008-.01-.034a1.7 1.7 0 0 1-.055-.555.9.9 0 0 1 .148-.446.88.88 0 0 1 .455-.325c1.04-.2 1.797-.523 2.298-.957.512-.443.741-.99.741-1.586 0-.576-.242-1.13-.673-1.537A2.37 2.37 0 0 0 12 5.465c-.61 0-1.195.229-1.627.637a2.13 2.13 0 0 0-.66 1.3H8.158c.06-.878.457-1.71 1.12-2.336A3.97 3.97 0 0 1 12 4c1.021 0 2 .383 2.722 1.066a3.54 3.54 0 0 1 1.128 2.573c0 1.692-1.222 3.112-2.888 3.522zm7.318 7.23c.26 0 .52-.13.659-.364a.685.685 0 0 0-.279-.98l-.002-.001L12 12.783l-8.068 4.409a.685.685 0 0 0-.279.98c.14.234.4.363.66.363z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }